import {useMemo} from 'react';
import {GetContractsQueryParams, useGetContractsQuery} from '../../../global/services/contracts';
import {useDebounce} from '../../../hooks/useDebounce';
import {prepareFilterParam} from '../helpers/prepare-filter-param.helper';
import {useContractsTableSearchStore} from '../stores/contracts-search.store';
import {useContractsTableFiltersStore} from '../stores/contracts-table-filters.store';
import {useContractsTableStore} from '../stores/contracts-table.store';

export const useContractsTableData = () => {
  const filters = useContractsTableFiltersStore((s) => s.filters);
  const {archive, page, size, order} = useContractsTableStore();
  const {searchQuery, searchCategory} = useContractsTableSearchStore();
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const debouncedSearchCategory = useDebounce(searchCategory, 300);

  const queryParams = useMemo(() => {
    if (!debouncedSearchQuery) return {};
    return {[debouncedSearchCategory]: debouncedSearchQuery};
  }, [debouncedSearchCategory, debouncedSearchQuery]);

  const filterParams = useMemo<GetContractsQueryParams>(
    () => filters.reduce((acc, filter) => ({...acc, ...prepareFilterParam(filter)}), {}),
    [filters],
  );

  const {data, loading} = useGetContractsQuery({
    page,
    size,
    archive,
    order: order(),
    ...queryParams,
    ...filterParams,
  });

  return {
    data,
    loading,
  };
};
